import {
  CHECKOUT_SET_GIFT_MESSAGE,
  CHECKOUT_SET_GIFT_OPTIONS,
  CHECKOUT_SET_GIFT_OPTIONS_LOADING,
  CHECKOUT_SET_GIFT_OPTIONS_STATE,
  CHECKOUT_SET_USE_GIFT_BAG,
  CHECKOUT_SET_USE_GIFT_RECEIPT
} from 'constants/reduxActions';

import { catchHandlerFactory } from 'actions/checkout/purchase';
import { setSessionCookies } from 'actions/session';
import { getGiftOptions } from 'apis/mafia';
import {
  fetchApiNotAuthenticatedMiddleware,
  fetchErrorMiddleware
} from 'middleware/fetchErrorMiddleware';
import { processHeadersMiddleware } from 'middleware/processHeadersMiddlewareFactory';

export function defaultEndpoints() {
  return { getGiftOptions };
}

export function setGiftMessage(giftMessage) {
  return { type: CHECKOUT_SET_GIFT_MESSAGE, giftMessage };
}

export function setUseGiftReceipt(useGiftReceipt) {
  return { type: CHECKOUT_SET_USE_GIFT_RECEIPT, useGiftReceipt };
}

export function setUseGiftBag(useGiftBag) {
  return { type: CHECKOUT_SET_USE_GIFT_BAG, useGiftBag };
}

export function setGiftOptionsIsLoading(isLoading) {
  return { type: CHECKOUT_SET_GIFT_OPTIONS_LOADING, isLoading };
}

export function setGiftOptions(giftOptions) {
  return { type: CHECKOUT_SET_GIFT_OPTIONS, giftOptions };
}

export function setGiftOptionsState(params) {
  const { giftMessage, useGiftReceipt, useGiftBag, lineItemId } = params;
  return {
    type: CHECKOUT_SET_GIFT_OPTIONS_STATE,
    giftMessage,
    useGiftReceipt,
    useGiftBag,
    lineItemId
  };
}

export function fetchGiftOptions(mafiaEndpoints = defaultEndpoints()) {
  return function(dispatch, getState) {
    const {
      cookies,
      checkoutData: {
        purchaseData: {
          data: { purchaseId }
        }
      },
      environmentConfig: { api: { mafia } }
    } = getState();

    if (!purchaseId) {
      return;
    }

    dispatch(setGiftOptionsIsLoading(true));
    return mafiaEndpoints.getGiftOptions({ ...mafia, purchaseId }, cookies)
      .then(processHeadersMiddleware(setSessionCookies(dispatch)))
      .then(fetchApiNotAuthenticatedMiddleware)
      .then(fetchErrorMiddleware)
      .then(response => {
        dispatch(setGiftOptionsIsLoading(false));
        dispatch(setGiftOptions(response));
      })
      .catch(catchHandlerFactory(dispatch));
  };
}
